import { IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import StatusOk from '../../../assets/svgs/upload-svgs/statusOk';
import StatusRejected from '../../../assets/svgs/upload-svgs/statusRejected';

const UploadStatusEachDoc = ({ doc }) => {
    if (doc.status === "ok") {
        return (
            <Tooltip title={"تایید شده"} placement='bottom' arrow={true}>
                <IconButton size='small'>
                    <StatusOk />
                </IconButton>
            </Tooltip>
        )
    } else if (doc.status === "rejected") {
        return (<Tooltip title={doc.description} placement='bottom' arrow={true}>
            <IconButton size='small'>
                <StatusRejected />
            </IconButton>
        </Tooltip>)
    }
};

export default UploadStatusEachDoc;